import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuItemPartnerIndexQuerySchema } from '~/services/api/generated'

const schema = MenuItemPartnerIndexQuerySchema.strict()

// ListMenuItemsRequest
export const MenuItemPartnerIndex = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  schema
